<template>
  <div class="stillvorbereitung">
    <div class="next-event-bubble-wrap-zone">
      <h1>Stillvorbereitung: Dein Online-Stillkurs für einen selbstsicheren Stillstart</h1>
      <p>Die Zeit vor der Geburt ist voller Veränderungen – körperlich, emotional und organisatorisch. Zwischen Geburtsvorbereitung, Kliniktasche packen und Baby-Erstausstattung bleibt das Thema Stillen oft im Hintergrund. Dabei ist genau jetzt der richtige Moment für eine gezielte Stillvorbereitung. In meinem Stillkurs erfährst du alles, was du für einen selbstsicheren Stillstart wissen musst.</p>
      <p>Denn viele Stillprobleme entstehen durch Unsicherheit und fehlendes Wissen – gerade wenn in den ersten Tagen viele Meinungen und Tipps auf einen einprasseln. Mit einer guten Vorbereitung kannst du genau das vermeiden. Du stärkst das Vertrauen in dich und deinen Körper und bekommst realistische Erwartungen an die erste Zeit nach der Geburt.</p>
    </div>
    <p>Ein Stillvorbereitungskurs bietet dir die Möglichkeit, dich ganz bewusst mit dem Thema auseinanderzusetzen – <i>ohne Druck, ohne Stress, mit viel Raum für Fragen</i>. Du erfährst, wie du dein Baby richtig anlegst, welche Stillpositionen euch den Start erleichtern können und wie Milchbildung eigentlich funktioniert. Auch mögliche Anfangsschwierigkeiten und wie du damit umgehen kannst, sind Teil meines Kurses.</p>
    <p>Wenn du selbstsicher in die Stillzeit starten willst oder noch gar nicht entschieden hast, ob du Stillen möchtest und einfach Informationen suchst, dann ist ein Stillvorbereitungskurs genau das richtige für dich!</p>
    <h2>Die Inhalte deines Stillvorbereitungskurses:</h2>
    <ul>
      <li>Wie funtionieren Stillen und Milchbildung?</li>
      <li>Vorteile des Stillens</li>
      <li>Der "perfekte" Stillstart</li>
      <li>Unterschiedliche Stillpositionen & korrektes Anlegen</li>
      <li>Stilldauer und -häufigkeit, was ist normal?</li>
      <li>Die häufigsten Stillprobleme</li>
      <li>Erste Hilfe bei wunden Brustwarzen</li>
      <li>Aufklärung über Stillmythen</li>
    </ul>
    <p>Selbstverständlich haben wir am Ende auch Zeit für all deine Fragen. Bitte habe jedoch Verständnis, dass eine individuelle <router-link to="/stillberatung">Stillberatung</router-link> aufgrund der begrenzten Zeit nicht möglich ist.</p>
    <NextEventBubble />
    <p>
      Ihr seid mindestens zu viert und möchtet einen <strong>privaten Kurs für eure Gruppe</strong>? Online oder vielleicht sogar ganz bequem bei euch zu Hause? Kein Problem – wir finden einen Termin und ich komme gerne vorbei!
    </p>
  </div>
</template>

<script>
import NextEventBubble from "@/components/NextEventBubble.vue";

export default {
  name: 'Stillvorbereitung',
  components: {
    NextEventBubble
  }
}
</script>

<style scoped>
.stillvorbereitung {
}
@media (min-width: 70rem) {
  .next-event-bubble-wrap-zone {
    padding-right: clamp(0rem, 50rem + -50vw, 15rem);
  }
}
</style>